import React from "react";
import { Routes, Route } from "react-router-dom";
import FreelancerBasicInfoPage from "../pages/FreelancerBasicInfoPage.jsx";
import FreelancerAccountInfoPage from "../pages/FreelancerAccountInfoPage.jsx";
import FreelancerAccountStatusHistoryPage from "../pages/FreelancerAccountStatusHistoryPage.jsx";
import FreelancerEmailVerificationPage from "../pages/FreelancerEmailVerificationPage.jsx";
import FreelancerSubscriptionInfoPage from "../pages/FreelancerSubscriptionInfoPage.jsx";
import FreelancerSubscriptionInfoHistoryPage from "../pages/FreelancerSubscriptionInfoHistoryPage.jsx";
import FreelancerPreferencesPage from "../pages/FreelancerPreferencesPage.jsx";
import OrdersPage from "../pages/OrdersPage.jsx";
import FreelancerPayoutSummaryPage from "../pages/FreelancerPayoutSummaryPage.jsx";
import FreelancerPayoutTransactionsPage from "../pages/FreelancerPayoutTransactionsPage.jsx";
import FreelancerWithdrawalBankDetailsPage from "../pages/FreelancerWithdrawalBankDetailsPage.jsx";
import EvaluationTrackerPage from "../pages/EvaluationTrackerPage.jsx";
import EmployeesPage from "../pages/EmployeesPage.jsx";
import ClientsPage from "../pages/ClientsPage.jsx";
import FreelancerBankChangeLogsPage from "../pages/FreelancerBankChangeLogsPage.jsx";
import FreelancerCompleteInfoPage from "../pages/FreelancerCompleteInfoPage.jsx";


import SupportTicketsPage from "../pages/support/SupportTicket.jsx";
import TicketListPage from "../pages/support/TicketList.jsx";
import ChatWindowPage from "../pages/support/ChatWindow.jsx";
import TaskInfoPage from "../pages/TaskInfoPage.jsx";
import BeginnerMcqsPage from "../pages/BeginnerMcqsPage.jsx";
import CreateNewEmployeePage from "../pages/OfficeManagement/CreateNewEmployeePage.jsx";
import FreelancerBlockPage from "../pages/OfficeManagement/BlockFreelancerPage.jsx";

import EmployeeLoginPage from "../EmployeeLoginPage.jsx";
import ProtectedRoute from "../context/ProtectedRoute.js";
import SubscriptionsAndPayoutsPage from "../pages/CEO-dashboard/SubscriptionsAndPayoutsPage.jsx";
import FreelancerOrderSummaryPage from "../pages/CEO-dashboard/FreelancersVsOrdersPage.jsx";
import FreelancerEarningsSummaryPage from "../pages/CEO-dashboard/FreelancersVsEarningsPage.jsx";
import DailyReportNumbersPage from "../pages/CEO-dashboard/DailyReportNumbersPage.jsx";
import DailyReportChartPage from "../pages/CEO-dashboard/DailyReportChartPage.jsx";
import DailyReportChartPageV2 from "../pages/CEO-dashboard/DailyReportChartPageV2.jsx";
import BKFreelancerPayInDataPage from "../pages/Bookkeeper-data/BK-FreelancerPayInDataPage.jsx";
import BKFreelancerPayOutDataPage from "../pages/Bookkeeper-data/BK-FreelancerPayOutDataPage.jsx";


const AppRoutes = () => {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/freelancer-basic-info" element={<FreelancerBasicInfoPage />} />
      <Route path="/freelancer-account-info" element={<FreelancerAccountInfoPage />} />
      <Route path="/freelancer-account-status-history" element={<FreelancerAccountStatusHistoryPage />} />
      <Route path="/freelancer-email-verification" element={<FreelancerEmailVerificationPage />} />
      <Route path="/freelancer-subscription-info" element={<FreelancerSubscriptionInfoPage />} />
      <Route path="/freelancer-subscription-info-history" element={<FreelancerSubscriptionInfoHistoryPage />} />
      <Route path="/freelancer-preferences" element={<FreelancerPreferencesPage />} />
      <Route path="/orders" element={<OrdersPage />} />
      <Route path="/freelancer-payout-summary" element={<FreelancerPayoutSummaryPage />} />
      <Route path="/freelancer-payout-transactions" element={<FreelancerPayoutTransactionsPage />} />
      <Route path="/freelancer-withdrawal-bank-details" element={<FreelancerWithdrawalBankDetailsPage />} />
      <Route path="/evaluation-tracker" element={<EvaluationTrackerPage />} />
      <Route path="/beginner-mcqs" element={<BeginnerMcqsPage />} />
      <Route path="/" element={<EmployeeLoginPage />} />
      <Route path="/employee-login" element={<EmployeeLoginPage />} />

      <Route path="/subscriptions-and-payouts" element={<SubscriptionsAndPayoutsPage />} />

      <Route path="/freelancer-order-data" element={<FreelancerOrderSummaryPage  />} />
      <Route path="/freelancer-earning-data" element={<FreelancerEarningsSummaryPage  />} />
      <Route path="/daily-report-numbers" element={<DailyReportNumbersPage  />} />
      <Route path="/daily-report-chart" element={<DailyReportChartPage  />} />
      <Route path="/daily-report-chart-v2" element={<DailyReportChartPageV2  />} />
      <Route path="/bk-freelancer-payin" element={<BKFreelancerPayInDataPage  />} />
      <Route path="/bk-freelancer-payout" element={<BKFreelancerPayOutDataPage  />} />


      {/* Protected admin routes */}
      <Route
        path="/employees"
        element={
          <ProtectedRoute>
            <EmployeesPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/create-new-employee"
        element={
          <ProtectedRoute>
            <CreateNewEmployeePage />
          </ProtectedRoute>
        }
      />

	<Route
	  path="/block-freelancer"
	  element={
	    <ProtectedRoute>
	      <FreelancerBlockPage />
	    </ProtectedRoute>
	  }
	/>



      <Route
        path="/clients"
        element={
          <ProtectedRoute>
            <ClientsPage />
          </ProtectedRoute>
        }
      />


<Route
  path="/freelancer-bank-change-logs"
  element={
    <ProtectedRoute>
      <FreelancerBankChangeLogsPage />
    </ProtectedRoute>
  }
/>



<Route
  path="/freelancer-complete-info"
  element={
    <ProtectedRoute>
      <FreelancerCompleteInfoPage />
    </ProtectedRoute>
  }
/>


      <Route
        path="/support-tickets"
        element={
          <ProtectedRoute>
            <SupportTicketsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/task-info"
        element={
          <ProtectedRoute>
            <TaskInfoPage />
          </ProtectedRoute>
        }
      />
      {/* Optional — if these should be admin-only */}
      <Route
        path="/ticket-list"
        element={
          <ProtectedRoute>
            <TicketListPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/chat-window"
        element={
          <ProtectedRoute>
            <ChatWindowPage />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
};

export default AppRoutes;
